export const links = [
	{
		regex: /campona.hu/,
		callback: () => {
			(window as any).open('https://campona.hu', '_blank').focus();
		},
	},
	{
		regex: /HPS_performance/,
		callback: () => {
			(window as any).open('https://hps.hu/communication/services/digital/online-media-performance-marketing', '_blank').focus();
		},
	},
	{
		regex: /feat.agency/,
		callback: () => {
			(window as any).open('https://feat.agency', '_blank').focus();
		},
	},
	{
		regex: /spagobudapest.com/,
		callback: () => {
			(window as any).open('https://spagobudapest.com', '_blank').focus();
		},
	},
	{
		regex: /Campona App/,
		callback: () => {
			(window as any).open('https://feat.agency/collaborations/campona-website-app', '_blank').focus();
		},
	},
	{
		regex: /spagobudapest.com/,
		callback: () => {
			(window as any).open('https://spagobudapest.com', '_blank').focus();
		},
	},
	{
		regex: /theduchessbudapest.com/,
		callback: () => {
			(window as any).open('https://theduchessbudapest.com', '_blank').focus();
		},
	},
	{
		regex: /autotartosberlet.hu/,
		callback: () => {
			(window as any).open('https://autotartosberlet.hu', '_blank').focus();
		},
	},
	{
		regex: /targoncavasarlas.hu/,
		callback: () => {
			(window as any).open('https://targoncavasarlas.hu', '_blank').focus();
		},
	},
	{
		regex: /youngart.hu/,
		callback: () => {
			(window as any).open('https://youngart.hu', '_blank').focus();
		},
	},
];
